module.exports = __webpack_public_path__ + "img/gs.15333083.svg";